var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(" 2025 © 法語鸚鵡螺 by "),_c('a',{attrs:{"href":"https://jbravo.com.tw"}},[_vm._v("嵩鴻數位有限公司")])])])])])
}]

export { render, staticRenderFns }